import axios from 'axios';

const BASE_URL = '/painel-api/api/cliente-property';

type ClientePropertyName =
  | 'WELCOME_EMAIL_EXTERNO_ENABLED'
  | 'WELCOME_EMAIL_EXTERNO_SUBJECT'
  | 'WELCOME_EMAIL_EXTERNO_BODY'
  | 'WELCOME_EMAIL_INTERNO_SUBJECT'
  | 'WELCOME_EMAIL_INTERNO_BODY'
  | 'WELCOME_EMAIL_INTERNO_BODY_HTML'
  | 'WELCOME_EMAIL_INTERNO_ENABLED'
  | 'WELCOME_EMAIL_EXTERNO_BODY_HTML'
  | 'VALIDAR_CERTIFICADO_DIGITAL_PJ';

export const getValueByName = (name: ClientePropertyName) =>
  axios.get(`${BASE_URL}/${name}`);
